import React from "react";
import "./home.css";

function Home() {
  return (
    <section id="home-hero" className="hero-minimal">
      <div className="hero-minimal__inner">
        <p className="hero-minimal__eyebrow">Hi, my name is</p>
        <h1 className="hero-minimal__name">Javian Anderson.</h1>
        <h2 className="hero-minimal__role">
          I find out what actually happened.
        </h2>
        <p className="hero-minimal__bio">
          I've spent the first four years of my career in enterprise
          security, moving from security operations into leading email
          security and identity for a Caribbean telecom. Lately I've been
          drawn toward the investigative side of the work, digital
          forensics, because that's the part of the job I enjoy most.
        </p>
        <div className="hero-minimal__cta">
          <a href="/about/" className="hero-minimal__btn">
            More about me
          </a>
          <a href="/projects/" className="hero-minimal__btn">
            View my projects
          </a>
          <a href="/blogs/" className="hero-minimal__link">
            Read my blog &rarr;
          </a>
        </div>
        <div className="hero-minimal__social" aria-label="Social links">
          <a
            href="https://www.linkedin.com/in/andersonjavian/"
            target="_blank"
            rel="noreferrer"
            aria-label="LinkedIn"
          >
            <i className="fab fa-linkedin"></i>
          </a>
          <a
            href="https://www.instagram.com/javian.zinga/"
            target="_blank"
            rel="noreferrer"
            aria-label="Instagram"
          >
            <i className="fab fa-instagram"></i>
          </a>
          <a
            href="https://twitter.com/manueljanderson"
            target="_blank"
            rel="noreferrer"
            aria-label="Twitter"
          >
            <i className="fab fa-twitter"></i>
          </a>
          <a
            href="https://www.facebook.com/OfficialManuel1"
            target="_blank"
            rel="noreferrer"
            aria-label="Facebook"
          >
            <i className="fab fa-facebook"></i>
          </a>
        </div>
      </div>
    </section>
  );
}

export default Home;
